// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App'
import ViewRouter from 'vue-router'
import routes from './router/router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
require('promise.prototype.finally').shim();

// import axios from 'axios'
// import VueAxios from 'vue-axios'

Vue.use(ViewRouter)
Vue.use(ElementUI)
// Vue.use(axios)
// Vue.use(VueAxios)

const router = new ViewRouter({
    routes,
    mode: 'hash',
    strict: process.env.NODE_ENV !== 'production',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            if (from.meta.keepAlive) {
                from.meta.savedPosition = document.body.scrollTop;
            }
            return { x: 0, y: to.meta.savedPosition || 0 }
        }
    }
})

/* eslint-disable no-new */
new Vue({
  // el: '#app',
  router,
  // components: { App },
  // template: '<App/>'
  // render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js